var map = {
	"./advania.png": 398,
	"./airbnb.png": 399,
	"./apress.svg": 400,
	"./aranja.svg": 401,
	"./archilogic.svg": 402,
	"./ccp.png": 403,
	"./facebook.png": 404,
	"./flipkart.svg": 405,
	"./gitlab.svg": 406,
	"./hardrock.png": 407,
	"./icelandair.svg": 408,
	"./kosmos-og-kaos.svg": 409,
	"./lb.jpg": 410,
	"./microsoft.png": 411,
	"./mozilla.svg": 412,
	"./net-app.png": 413,
	"./origo.svg": 414,
	"./tempo.png": 415,
	"./twg.svg": 416,
	"./twilio.png": 417,
	"./ueno.png": 418,
	"./wuxi-nextcode.svg": 419
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 397;



//////////////////
// WEBPACK FOOTER
// ../images/sponsors ^\.\/.*$
// module id = 397
// module chunks = 0